import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

// Sourced attribute schema (new structure from backend)
const sourcedAttributeSchema = z.object({
  source: z.enum(["catalog", "listing"]),
  value: z.any(), // Original attribute value (varies by attribute type)
});

const catalogAttributesSchema = z.record(z.string(), sourcedAttributeSchema).optional();

const catalogImageVariantSchema = z.object({
  variant: z.string(),
  link: z.string(),
  width: z.number(),
  height: z.number(),
});

const catalogImageSchema = z.object({
  images: z.array(catalogImageVariantSchema),
});

const catalogRelationshipSchema = z.object({
  parentAsins: z.array(z.string()).optional(),
});

const catalogSchema = z.object({
  attributes: catalogAttributesSchema,
  images: z.array(catalogImageSchema).optional(),
  relationships: z
    .array(
      z.object({
        relationships: z.array(catalogRelationshipSchema).optional(),
      }),
    )
    .optional(),
});

const catalogResponseSchema = z.object({
  catalog: catalogSchema,
  has_listing: z.boolean(),
});

export const catalogApiDefinitions = prefixApi(
  "/merchandise",
  apiBuilder({
    alias: "getCatalog",
    method: "get",
    path: "/catalog",
    parameters: [{ name: "product_id", type: "Query", schema: z.coerce.number() }],
    status: 200,
    response: catalogResponseSchema,
  }).build(),
);
